export const doRecursive = (field) => {
  let current;
  function findItem(items, cb) {
    current = items.find(cb);
    if (current !== undefined) return current;

    return items.reduce(
      (intermediateResult, item) => (
        !intermediateResult && Reflect.has(item, field) && Array.isArray(item[field])
          ? findItem(item[field], cb)
          : intermediateResult
      ),
      current
    );
  }

  return items => ({
    find: cb => findItem(items, cb)
  });
};

export default doRecursive;
